import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Children } from 'react';
import StickyBox from 'react-sticky-box';
import warning from 'warning';
import { css } from '../system';
import StackView from '../StackView';
import SidebarList from './SidebarList';
import SidebarItem from './SidebarItem';
var flexColumnCss = css({
  display: 'flex',
  flexDirection: 'column'
});

function Sidebar(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return jsx(StackView, _extends({
    grow: 1,
    paddingTop: 2,
    boxShadow: "inset -8px 0px 8px -8px rgba(150, 150, 150, 0.25)",
    backgroundColor: "surfaceTertiary"
  }, restProps), jsx(StickyBox, {
    css: flexColumnCss
  }, Children.map(children, function (child) {
    warning(child && child.type !== Sidebar.List || child && child.type !== Sidebar.Item, "Invalid component nesting. " + child.type + " cannot appear as a child of <Sidebar>. Only <Sidebar.List/> or <Sidebar.Item/> may be used.");
    return child;
  })));
}

Sidebar.List = SidebarList;
Sidebar.Item = SidebarItem;
export default Sidebar;